export default "__VITE_ASSET__DjgQq57R__"